// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"b2b85a38","195":"dfb797e0","299":"2b91711e","451":"74c62ea4","453":"668de03b","459":"214dc191","583":"10146321","919":"6d789b34"}[chunkId] + ".chunk.js";
};